import SubscriptionForm from "@components/SubscriptionForm"
import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"
import { Plan, StripePrice } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  fullPrice: StripePrice | undefined
  plan: Plan
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  timeLeft: string
}

export default function LimitedTimeOfferBanner({
  currency,
  isSubmitting,
  fullPrice,
  plan,
  priceId,
  setIsSubmitting,
  timeLeft,
}: Props) {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const plansCopyKey =
    context === "cars"
      ? "pages.checkout.plansCars"
      : context === "pets"
        ? "pages.checkout.plansPets"
        : isHomeFlow()
          ? "pages.checkout.plansHome"
          : "pages.checkout.plans"

  return (
    <div className="bg-white">
      <div className="custom-container flex items-center justify-between py-4">
        <div className="flex flex-col gap-1 text-black">
          <p className="text-sm font-semibold">
            {t(`${plansCopyKey}.discount_reserved`)}
          </p>
          <p className="text-2xl font-semibold">{timeLeft}</p>
        </div>

        <SubscriptionForm
          buttonClassName="rounded-2xl! bg-black! px-6! py-2! font-semibold! text-sm! text-white! shadow-none!"
          buttonTitle={t(`${plansCopyKey}.startNow`)}
          currency={currency}
          fullPrice={fullPrice}
          isSubmitting={isSubmitting}
          plan={plan}
          priceId={priceId}
          setIsSubmitting={setIsSubmitting}
        />
      </div>
    </div>
  )
}
